<template>
  <div class="login-container">
    <!-- Background shapes -->
    <div class="login-bg">
      <div class="bg-circle bg-1"></div>
      <div class="bg-circle bg-2"></div>
      <div class="bg-circle bg-3"></div>
    </div>

    <div class="login-wrapper">
      <FormLogin />
    </div>
  </div>
</template>

<script>
import FormLogin from '@/components/auth/FormLogin.vue'
import Auth from '@/services/auth.service.js'

export default {
  name: 'LoginView',
  components: {
    FormLogin
  },
  mounted() {
    let auth = Auth.checkAuth();
    if (auth) {
      this.$router.replace({ name: "home" })
    }
  },
}
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f4f8;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* Background decorations */
.login-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.04;
}

.bg-1 {
  width: 500px;
  height: 500px;
  background: #2196F3;
  top: -150px;
  right: -100px;
}

.bg-2 {
  width: 350px;
  height: 350px;
  background: #4CAF50;
  bottom: -80px;
  left: -80px;
}

.bg-3 {
  width: 250px;
  height: 250px;
  background: #FF9800;
  top: 40%;
  left: 5%;
}

.login-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(24px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@media (max-width: 600px) {
  .login-container {
    padding: 12px;
  }
}
</style>